import { IApplicationState } from '../types/redux';

export const selectPickedSpecialists = (state: IApplicationState) => state.realtors.specialists;
